/**
 * <LiveReportDetailsPage> — the full live-report detail screen (`/r?h=…`) rebuilt on the DS (page, L0.1).
 *
 * A detail page (no bottom tab): a `<Header>` ("Rapport de séance" + a close action) over the
 * `<LiveReportDetailsTemplate>`, which owns the whole report layout (hero → bilan → satisfaction →
 * engagement → chapters → activities → bottom Sam CTA). Pure composition — data in as the typed
 * `UILiveSessionReportDetails`, events out as callbacks. No Redux, no navigation — renderable in Storybook.
 */
import { type NativeScrollEvent, type NativeSyntheticEvent } from "react-native"

import { IconButton } from "../../atoms/Buttons/IconButton"
import { Header } from "../../molecules/Header"
import { LiveReportDetailsTemplate } from "../../templates/LiveReportDetailsTemplate"
import { PageTemplate } from "../../templates/PageTemplate"
import { type UILiveSessionReportDetails } from "../../../ports/primary/ui/types"
import { LiveReportDetailsSkeleton } from "./LiveReportDetailsSkeleton"

export type LiveReportDetailsPageProps = {
    report: UILiveSessionReportDetails | null
    loading?: boolean
    error?: unknown
    onRetry?: () => void
    /** Close / back out of the report. */
    onClose?: () => void
    /** "Je prends rdv avec mon conseiller" (Sam Calendly CTA — top hero + bottom block). */
    onSamPress?: () => void
    /** Scroll handler (NPS / referral triggers) — forwarded to `<PageTemplate>`. */
    onScroll?: (event: NativeSyntheticEvent<NativeScrollEvent>) => void
}

export function LiveReportDetailsPage(props: LiveReportDetailsPageProps) {
    const { report, loading = false, error, onRetry, onClose, onSamPress, onScroll } = props

    const header = (
        <Header
            title="Rapport de séance"
            left={<IconButton iconName="times" appearance="transparent" iconColor="primary" onPress={onClose} />}
        />
    )

    return (
        <PageTemplate
            header={header}
            loading={loading}
            skeleton={<LiveReportDetailsSkeleton />}
            error={error}
            onRetry={onRetry}
            onScroll={onScroll}
        >
            {report != null ? <LiveReportDetailsTemplate report={report} onSamPress={onSamPress} /> : null}
        </PageTemplate>
    )
}
